













import Vue from 'vue'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'

export default Vue.extend({
  name: 'SettingListTwitterTwitter',
  components: {
    ConfirmModal
  },
  data() {
    return {
      isModalShown: false
    }
  },
  computed: {
    isConnected(): boolean {
      return !!(this.$state.users.profile && this.$state.users.profile.twitter_id)
    },
    iconClass(): string {
      return `ic-twitter`
    }
  },
  methods: {
    onModalShow() {
      this.isModalShown = true
    },
    onModalHidden() {
      this.isModalShown = false
    },
    connectTwitter() {
      window.open('/settings/twitter_auth', 'twitterWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1')
    },
    async disconnectTwitter() {
      await this.$store.dispatch('twitter/disconnectTwitter', {})
      this.isModalShown = false
      this.$store.dispatch('users/fetchProfile')
    }
  }
})
